import type { MockContact } from '../data/mockContacts';
import { formatShortSpan, getCadence } from './contactInsights';

const csvCell = (value: string) => /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

function cadenceLabel(contact: MockContact): string {
  const cadence = getCadence(contact.insights);
  if (!cadence) return '';
  if (cadence.status === 'lapsed') return `Lapsed · ${formatShortSpan(cadence.days)} overdue`;
  return cadence.status === 'due-soon' ? 'Due soon' : 'On track';
}

// Downloads a CSV call list: name, phone, top product, last order, cadence status
export function downloadCallList(contacts: MockContact[]): void {
  const rows = [['Name', 'Phone', 'Top product', 'Last order', 'Cadence status'], ...contacts.map(contact => [contact.name, contact.phone, contact.insights.topProduct, contact.lastOrder, cadenceLabel(contact)])];
  const csv = rows.map(row => row.map(csvCell).join(',')).join('\n');
  const url = URL.createObjectURL(new Blob([csv], {
    type: 'text/csv;charset=utf-8'
  }));
  const link = document.createElement('a');
  link.href = url;
  link.download = `call-list-${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
